import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { StatusBar, Style } from "@capacitor/status-bar";

export type MobileLifecycleHandlers = {
  onBackground(): void;
  onForeground(): void;
  onBackButton(): void;
};

export class MobilePlatform {
  readonly native = Capacitor.isNativePlatform();

  async initialize(handlers: MobileLifecycleHandlers): Promise<void> {
    document.body.classList.toggle("native-app", this.native);
    if (!this.native) return;
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#1C1410" });
    }
    await App.addListener("appStateChange", ({ isActive }) => {
      document.body.classList.toggle("app-backgrounded", !isActive);
      if (isActive) handlers.onForeground();
      else handlers.onBackground();
    });
    await App.addListener("backButton", () => handlers.onBackButton());
  }

  private vibrate(pattern: number | number[]): void {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(pattern);
    }
  }

  async impact(enabled: boolean): Promise<void> {
    if (!enabled) return;
    if (!this.native) return this.vibrate(10);
    await Haptics.impact({ style: ImpactStyle.Light });
  }

  async success(enabled: boolean): Promise<void> {
    if (!enabled) return;
    if (!this.native) return this.vibrate([15, 30, 15]);
    await Haptics.notification({ type: NotificationType.Success });
  }

  async error(enabled: boolean): Promise<void> {
    if (!enabled) return;
    if (!this.native) return this.vibrate([30, 25, 30]);
    await Haptics.notification({ type: NotificationType.Error });
  }
}
